// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urls: {
    franchiseClients: '/uix/api/fam/clients',
    franchiseClientLocations: '/uix/api/fam/clientLocations',
    franchiseData: '/uix/api/fam/franchises',
    validateEmail: '/uix/api/validateEmail',
    userLocationsData: '/uix/api/fam/userLocationsData',
    associateClients: '/uix/api/fam/associate/clients',
    associateClientAttributes: '/uix/api/fam/associate/client/attributes',
    associateClientLocations: '/uix/api/fam/associate/client/locations',
    associateClientsAndAttributes: '/uix/api/fam/associate/clientsAndAttributes',
    userNDA: '/uix/api/fam/associate/client/nda',
    franchiseReportData: '/uix/api/fam/report',
    addCompassEmployee: '/uix/selfservice/api/compass_employee/add',
    validateCompassEmail: '/uix/selfservice/api/compass_employee/validate_email?page={page}&size={size}&orderby={orderBy}',
    validateCompassEmailV2: '/uix/selfservice/api/compass_employee/validate_email_v2?page={page}&size={size}&orderby={orderBy}&realm={realm}',
    validateCompassUser: '/uix/selfservice/api/validate_compass_user/{username}',
    validateCompassUserCreds: '/uix/selfservice/api/validate_compass_user_creds',
    getCompassEmployeeDetails: '/uix/selfservice/api/compass_employee',
    resetCompassEmployee: '/uix/selfservice/api/compass_employee/reset/{key}',
    createHelixWorkOrder: '/uix/selfservice/api/compass_employee/create_helix_work_order',
    checkOptInOutRequired: '/uix/api/adams/optinoutrequired?perno={perno}',
    getSelfSyncopeConfigurations: '/uix/selfservice/api/syncope/configuration',
    getSyncopeConfigurations: '/uix/api/syncope/configuration',
    getSelfRealmsDetails: '/uix/selfservice/api/realms',
    getRealmsDetails: '/uix/api/realms',
    disabledUsers: '/uix/identities/disabled/?page={page}&size={size}&orderBy={orderBy}&filter={filter}',
    updateDisabledUser : '/uix/identities/disabled/{employee_number}',
    addDisabledusers: '/uix/identities/disabled',
    disabledUsersResync: '/uix/identities/disabled/sync-now',
    resyncPernos: '/uix/api/resyncPerno',
    validateIdentity: '/uix/api/validate_identity',
    getAddressChange: '/uix/api/address?filter={filter}',
    upsertAddressChange: '/uix/api/address-change',
    adams: {
      addTeam: '/uix/api/users/userName/{userName}/applications/{application}/roles/{role}/addTeams',
      costCenters: '/uix/api/cost_centers',
      findACostCenterAndListDetails: '/uix/api/cost_centers/{cost_center}',
      jobCodes: '/uix/people/v1/JobCodes',
      getCostCentersByUserName: '/uix/api/users/cost_centers',
      costCenterByLoginUser: '/uix/api/users/applications/{application}/roles/{role}/hierarchicalteams',
      applicationsByUser: '/uix/api/users/{userName}/applications',
      getAllMyOrdersApplications:'/uix/api/myorders_applications',
      updateSecuredObjects: '/uix/api/users/secured_objects',
      updateMyOrdersApplicationsStatusForUser:'/uix/api/users/{userName}/myorders_applications',
      rolesByLoginUser: '/uix/api/users/applications/{application}/roles',
      rolesByUser: '/uix/api/users/{userName}/applications/{application}/roles',
      teamsByUser: '/uix/api/users/{userName}/applications/{application}/roles/{role}/teams',
      updateRole: '/uix/api/users/{userName}/applications/{application}/updateRole',
      changeDefaultRole: '/uix/api/users/{userName}/applications/{application}/defaultRoles/{role}',
      changeDefaultTeam: '/uix/api/users/{userName}/applications/{application}/roles/{role}/defaultTeams/{team}/sourcesystemid/{sourcesystemid}',
      deleteApp: '/uix/api/users/{userName}/applications/{application}',
      deleteRole: '/uix/api/users/{userName}/applications/{application}/roles/{role}',
      deleteTeam: '/uix/api/users/{userName}/applications/{application}/roles/{role}/teams/{team}/sourcesystemid/{sourcesystemid}',
      getUserProfile: '/uix/api/users/profile',
      getAdminBlockedApps : '/uix/api/adams/settings',
      getOrganizationsByUser: '/uix/api/users/applications/roles/foodbuy-member/orgs',
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
